/**
 * Created by michaelbray on 5/4/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    description: PropTypes.string,
    openGraphCard: PropTypes.string,
    twitterCard: PropTypes.string
};

const defaultProps = {
    title: "Recreation.gov - Bring Home a Story",
    url: "https://www.recreation.gov",
    description: "Recreation.gov is your source for discovering and experiencing America's federal recreation activities and outdoor adventures.",
    openGraphCard: "https://www.recreation.gov/FacebookOG.png",
    twitterCard: "https://www.recreation.gov/TwitterCard.png"
};

export default class HelmetWrapper extends React.PureComponent {
    render() {
        return null;
        /*
        TODO: removed - this is now managed by SEOService
        return (
            // Todo - Mike Bray: Confirm format of titleTemplate
            <Helmet titleTemplate="%s | Recreation.gov" defaultTitle="Recreation.gov - Bring Home a Story">
                <title>{this.props.title}</title>
                <meta name="description" content={this.props.description} />

                <meta property="og:title" content={this.props.title} />
                <meta property="og:url" content={this.props.url} />
                <meta property="og:description" content={this.props.description} />
                <meta property="og:image" content={this.props.openGraphCard} />

                <meta name="twitter:title" value={this.props.title} />
                <meta name="twitter:url" value={this.props.url} />
                <meta name="twitter:description" value={this.props.description} />
                <meta name="twitter:image" content={this.props.twitterCard} />
            </Helmet>
        );
         */
    }
}

HelmetWrapper.propTypes = propTypes;
HelmetWrapper.defaultProps = defaultProps;
